<template>
  <div>
    <b-container class="container card">
      <!-- search -->
      <div id="search"  class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
        <div class="form-group col-md-3">
                <label for="">الفصل الدراسى</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_classyears"
                >
                  <option
                    v-for="acc in classY"
                    :value="acc.id"
                    :key="acc.id"
                  >
                    <span> {{ acc.classs }} </span>
                    <span> {{ acc.classyear }} </span>
                  </option>
                </select>
              </div>
               <div class="form-group col-md-3">
                <label for="">كود الباص </label>
                 <input type="text" class="form-control" v-model="id" />
              </div>
             
              <div class="form-group col-md-3 p-4">
                
                <button v-if="c_print" @click="print" class="btn btn-success">
                  طباعة
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import {  mapGetters } from "vuex";
import indexLayout from "../../layouts/indexLayout.vue";

export default {
  name: "allsubscripe",
  data() {
    return {
      s_classyears:"",
      id : '',
      c_print:false
    }
  },
 
    created(){
      this.$emit('update:layout',indexLayout)
       this.Role_check();
    },
  computed: {
    ...mapGetters({
      classY: "classesMod/GET_ALLDATA",
      check : "GET_ROLES"
    })
    
  },
 
  methods: {
 
    print(){
    if(this.s_classyears != ""){
        var vl = this.classY.find((t)=>t.id == this.s_classyears);
        var sr = vl.classs + ' '+ vl.classyear;
    this.$router.push({ name: 'creditByBusR' ,params: {classyearsID : this.s_classyears,classyearsN : sr,bus_id : this.id} })
    }
  
    },
      Role_check(){
this.c_print =this.check.Report_creditByBus ==1 ? true : false;
}
  }
};
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
.dropdown-menu {
  z-index: 1600 !important; /* has to be larger than 1050 */
}
</style>
